import React from "react";

// Dark hero band used at the top of inner pages
const PageHero = ({ title, desc, children }) => (
  <section className="relative bg-navy-950 pt-36 pb-16 lg:pt-44 lg:pb-20 overflow-hidden">
    <div className="absolute inset-0 grid-pattern opacity-50" />
    <div className="absolute -top-32 right-0 w-[30rem] h-[30rem] rounded-full bg-amber-500/10 blur-[120px]" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
      <div className="max-w-3xl">
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl text-white leading-[1.1]">
          {title}
        </h1>
        {desc && (
          <p className="mt-5 text-lg text-slate-300 leading-relaxed">{desc}</p>
        )}
        {children}
      </div>
    </div>
  </section>
);

export default PageHero;
